<template>
<div class="animated fadeIn mt-5">
  <b-card v-if="loading" class="text-center">
    <i class="fa fa-spinner fa-spin fa-4x"></i>
  </b-card>
  <div v-if="!loading">

    <form enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event,false)">
      <div class="row">
        <div class="col-md-6">
          <b-card>
            <div slot="header">
              <strong>Família</strong>
              <a class="pull-right" :href="previewEmailUrl" target="_blank">Prévisualizar email quotas</a>
            </div>
            <b-form-row>
              <b-col md="3">
                <b-form-fieldset label="Código">
                  <b-form-input type="text" name="id" readonly v-model="item.id" placeholder="Código" ></b-form-input>
                </b-form-fieldset>
              </b-col>
              <b-col md="9">
                <b-form-fieldset label="Apelido">
                  <b-form-input type="text" name="surname" v-model="item.surname" placeholder="Apelido"  v-validate="'required'" :state="validateState('surname')"></b-form-input>
                  <b-form-invalid-feedback>
                    {{ errors.first('surname') }}
                  </b-form-invalid-feedback>
                </b-form-fieldset>
              </b-col>
            </b-form-row>
            <b-row>
              <b-col>
                <b-form-fieldset label="Estado">
                  <b-form-select name="state" v-model="item.state"  v-validate="{ required: true }" :state="validateState('state')" class="mb-3">
                    <option value="0">Inactivo</option>
                    <option value="1">Activo</option>
                  </b-form-select>
                </b-form-fieldset>
              </b-col>
              <b-col>
                <b-form-fieldset label="Ano de inicio">
                  <b-form-input type="text" name="year_started" v-model="item.year_started" placeholder="Ano de inicio" v-validate="{ required: true }" :state="validateState('year_started')" data-vv-validate-on="change" ></b-form-input>
                  <b-form-invalid-feedback>
                    {{ errors.first('year_started') }}
                  </b-form-invalid-feedback>
                </b-form-fieldset>
              </b-col>
              <b-col>
                <b-form-fieldset label="Tipo de sócio">
                  <b-form-select name="membership_type_id" v-model="item.membership_type_id"  :state="validateState('membership_type_id')" v-validate="{ required: true }"  :options="membershiptypes" class="mb-3">
                    <template v-slot:first>
                    <b-form-select-option :value="null" >-- escolha um tipo --</b-form-select-option>
                  </template>
                  </b-form-select>
                  <b-form-invalid-feedback>
                    {{ errors.first('membership_type_id') }}
                  </b-form-invalid-feedback>
                </b-form-fieldset>
              </b-col>
            </b-row>
            <b-form-fieldset label="Email">
              <b-form-input type="email" name="email" v-model="item.email" placeholder="Email" v-validate="{ required: true, email:true }" :state="validateState('email')" data-vv-validate-on="change" ></b-form-input>
              <b-form-invalid-feedback>
                {{ errors.first('email') }}
              </b-form-invalid-feedback>
            </b-form-fieldset>
            <b-form-fieldset label="Telefone">
              <b-form-input type="text" name="phone" v-model="item.phone" placeholder="Telefone" v-validate="{ required: true }" :state="validateState('phone')" data-vv-validate-on="change" ></b-form-input>
              <b-form-invalid-feedback>
                {{ errors.first('phone') }}
              </b-form-invalid-feedback>
            </b-form-fieldset>
            <b-form-fieldset label="Morada">
              <b-form-input type="text" name="address" v-model="item.address" placeholder="Morada" v-validate="{ required: true }" :state="validateState('address')" data-vv-validate-on="change" ></b-form-input>
              <b-form-invalid-feedback>
                {{ errors.first('address') }}
              </b-form-invalid-feedback>
            </b-form-fieldset>
            <b-form-row>
              <b-col md="4">
                <b-form-fieldset label="Código Postal">
                  <b-form-input type="text" name="zip_code" v-model="item.zip_code" placeholder="Código Postal" v-validate="{ required: true }" :state="validateState('zip_code')" data-vv-validate-on="change" ></b-form-input>
                  <b-form-invalid-feedback>
                    {{ errors.first('zip_code') }}
                  </b-form-invalid-feedback>
                </b-form-fieldset>
              </b-col>
              <b-col md="8">
                <b-form-fieldset label="Localidade">
                  <b-form-input type="text" name="locality" v-model="item.locality" placeholder="Localidade" v-validate="{ required: true }" :state="validateState('locality')" data-vv-validate-on="change" ></b-form-input>
                  <b-form-invalid-feedback>
                    {{ errors.first('locality') }}
                  </b-form-invalid-feedback>
                </b-form-fieldset>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col md="4">
                <b-form-fieldset label="País">
                  <b-form-select v-model="item.country_id" :options="countries" class="mb-3">
                    <template v-slot:first>
                    <b-form-select-option :value="null" >-- escolha um país --</b-form-select-option>
                  </template>
                  </b-form-select>
                  <b-form-invalid-feedback>
                    {{ errors.first('country_id') }}
                  </b-form-invalid-feedback>
                </b-form-fieldset>
              </b-col>
              <b-col md="8">
                <b-form-fieldset label="Código de Zona">
                  <b-form-select v-model="item.region_id" :options="regions" class="mb-3">
                    <template v-slot:first>
                      <b-form-select-option :value="null" >-- Automático --</b-form-select-option>
                    </template>
                  </b-form-select>
                  <b-form-invalid-feedback>
                    {{ errors.first('region_id') }}
                  </b-form-invalid-feedback>
                </b-form-fieldset>
              </b-col>
            </b-form-row>

            <b-form-fieldset label="Notas / Observações">
              <b-form-textarea type="text" :rows="10" name="notes" v-model="item.notes" placeholder="Notas / Observações" :state="validateState('notes')" data-vv-validate-on="change" ></b-form-textarea>
              <b-form-invalid-feedback>
                {{ errors.first('notes') }}
              </b-form-invalid-feedback>
            </b-form-fieldset>

            <div slot="footer">
              <div class="row">
                <div class="col-sm-3">
                  <router-link :to="{name:baseRoute + '.index'}" size="sm" variant="danger"><i class="fa fa-ban"></i> Cancelar</router-link>

                </div>
                <div class="col-sm-9 text-right">
                  <b-button type="submit" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar</b-button>
                  <b-button type="button" v-on:click="validateBeforeSubmit($event,true)" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar e fechar</b-button>
                </div>
              </div>
            </div>
          </b-card>
        </div>
        <!--/.col-->
        <div class="col-md-6">
          <b-card>
            <div slot="header">
              <strong>Pais</strong>
            </div>
            <b-table striped hover :items="item.parents.data" :fields="familyFields">

              <template v-slot:cell(view_more)="data">
                <router-link class="btn btn-primary" :to="{name:'familymembers.edit',  params: { id: data.item.id } }"><i class="fa fa-edit"></i></router-link>
              </template>
            </b-table>
          </b-card>
          <b-card>
            <div slot="header">
              <strong>Filhos</strong>
            </div>
            <b-table striped hover :items="item.children.data" :fields="familyFields">
              <template v-slot:cell(view_more)="data">
                <router-link class="btn btn-primary" :to="{name:'familymembers.edit',  params: { id: data.item.id } }"><i class="fa fa-edit"></i></router-link>
              </template>
            </b-table>
          </b-card>
          <b-card>
            <div slot="header">
              <strong>Quotas</strong>
            </div>
            <b-table striped hover :items="item.fees.data" sort-by="fee_year" :sort-desc="true" :fields="feesFields" :current-page="feesCurrentPage" per-page="10">
              <template v-slot:cell(state)="data">
                {{ states.translate(data.value, 'feeStates') }}
              </template>
              <template v-slot:cell(fee_value)="data">
                {{ data.value | currency }}
              </template>
              <template v-slot:cell(paid_value)="data">
                {{ data.value | currency }}
              </template>
            </b-table>
            <b-pagination
              v-model="feesCurrentPage"
              :total-rows="feesRows"
              :per-page="10"
              aria-controls="my-table"
            ></b-pagination>
          </b-card>
          <b-card>
            <div slot="header">
              <strong>Emails enviados</strong>
            </div>
            <b-table striped hover :items="item.sentemails.data" :fields="sentEmailsFields">
              <template v-slot:cell(state)="data">
                {{ states.translate(data.value, 'emails') }}
              </template>
            </b-table>
          </b-card>

        </div>
        <!--/.col-->
      </div>
    </form>

  </div>
</div>
</template>

<script>
import States from '@/components/Lists.js'
export default {
  name: 'FamiliesEdit',
  props: ['id'],
  data() {
    return {
      url: 'families',
      loading: true,
      states: States,
      baseRoute: 'families',
      showTeam: false,
      showPassword: false,
      feesCurrentPage: 1,
      countries: [],
      regions: [],
      membershiptypes: [],
      previewEmailUrl: '',
      item: {
        surname: '',
        state: 1,
        email: '',
        code: '',
        parents: { data: [] },
        children: { data: [] },
        fees: { data: [] },
        sentemails: { data: [] },
      },
      familyFields: [{
        key: 'name',
        sortable: true
      }, {
        key: 'code',
        label: "Cod Perfil",
        sortable: true
      }, {
        key: 'birth_date',
        label: 'Data de nascimento',
        sortable: true
      }, {
        key: 'view_more',
        label: '',
        sortable: true
      }],
      feesFields: [{
        label: 'Ano',
        key: 'fee_year',
        sortable: true
      }, {
        label: 'Valor',
        key: 'fee_value',
        sortable: true
      }, {
        label: 'Entidade',
        key: 'reference_entity',
        sortable: false
      }, {
        label: 'Referência',
        key: 'reference_reference',
        sortable: false
      }, {
        label: 'Estado',
        key: 'state',
        sortable: true
      }, {
        label: 'Valor pago',
        key: 'paid_value',
        sortable: true
      }, {
        label: 'Data pagamento',
        key: 'paid_at',
        sortable: true
      }],
      sentEmailsFields: [{
        label: 'Email',
        key: 'subject'
      }, {
        label: 'Estado',
        key: 'state'
      }, {
        label: 'Data',
        key: 'updated_at'
      }]
    }
  },
  computed: {
    feesRows() {
      return this.item.fees.data.length
    }
  },
  methods: {
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$bvToast.toast('Tem campos inválidos', { autoHideDelay: 5000, variant: 'danger', solid: true})
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    submit(e, close) {
      e.preventDefault()
      var data = {
        data: this.item
      }
      if (this.item.id) {
        this.axios.put(this.url + '/' + this.item.id, data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast('item gravado com sucesso', { autoHideDelay: 5000, variant: 'success', solid: true})
            if (close) {
              this.$router.push({
                name: this.baseRoute + '.index'
              })
            }
          })
          .catch(response => {
            this.$bvToast.toast('Não foi possivel gravar', { autoHideDelay: 5000, variant: 'danger', solid: true})
          })
      } else {
        this.axios.post(this.url, data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast('item gravado com sucesso', { autoHideDelay: 5000, variant: 'success', solid: true})
            this.$router.push({
              name: this.baseRoute + '.edit',
              params: {
                id: this.item.id
              }
            })
          })
          .catch(response => {
            this.$bvToast.toast('Não foi possivel gravar', { autoHideDelay: 5000, variant: 'danger', solid: true})
          })
      }
    }
  },
  created() {
    var id = this.$route.params.id
    this.previewEmailUrl = this.axios.defaults.baseURL + 'fees/previewEmail/' + id
    if (typeof id !== 'undefined') {
      this.axios.get(this.url + '/' + id)
        .then(response => {
          this.item = response.data.data
          this.loading = false
        })
        .catch(response => {
          this.$bvToast.toast('Esta família não existe', { autoHideDelay: 5000, variant: 'danger', solid: true})
          this.$router.push({
            name: this.baseRoute + '.index'
          })
        })
    } else {
      this.loading = false
    }

    this.axios.get('countries/lst').then(response => {
      this.countries = response.data.data
    })
    this.axios.get('regions/lst').then(response => {
      this.regions = response.data.data
    })
    this.axios.get('membershiptypes/lst').then(response => {
      this.membershiptypes = response.data.data
    })
  }
}
</script>
